module.exports = __webpack_public_path__ + "img/El Salvador.7cb7b810.svg";